export default __webpack_public_path__ + "static/media/osilogo.537eda13.png";